{
  "familyId": "TOPO-EU-LAND",
  "questions": [
    {
      "id": "TOPO-EU-LAND-001",
      "familyId": "TOPO-EU-LAND",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_landen_eu",
      "questionType": "multiple_choice",
      "question": "Welk land heeft de vorm van een laars op de kaart van Europa?",
      "options": ["Italië", "Spanje", "Griekenland", "Kroatië"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Italië op de kaart", "content": "Italië is het land dat op de kaart de vorm van een laars heeft. Het steekt uit in de Middellandse Zee. De 'punt' van de laars wijst naar het eiland Sicilië.", "icon": "lightbulb"}}],
      "conceptId": "eu_country_shape_italy",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.81,
      "feedback": {
        "explanationText": "Italië is een schiereiland dat uitsteekt in de Middellandse Zee. De vorm lijkt op een laars — de 'hak' is in het zuidoosten (Puglia) en de 'punt' wijst naar Sicilië. Dit is de bekendste landvorm van Europa.",
        "solutionSteps": ["Italië is een schiereiland in Zuid-Europa", "Het steekt uit in de Middellandse Zee", "De vorm lijkt op een laars", "De 'punt' wijst naar het eiland Sicilië"],
        "distractorExplanations": {
          "0": "Goed! Italië heeft de herkenbare laarsvorm op de kaart van Europa.",
          "1": "Spanje ligt op het Iberisch Schiereiland en heeft een meer vierkante, compacte vorm. Onthoud: het laarsland is Italië.",
          "2": "Griekenland heeft een grillige kustlijn met veel eilanden, niet de laarsvorm. Onthoud: Italië = laars, Griekenland = grillige kust met eilanden.",
          "3": "Kroatië heeft een gebogen kustlijn langs de Adriatische Zee, maar niet de laarsvorm. Onthoud: het laarsland is Italië, in het zuiden van Europa."
        }
      }
    },
    {
      "id": "TOPO-EU-LAND-002",
      "familyId": "TOPO-EU-LAND",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_landen_eu",
      "questionType": "multiple_choice",
      "question": "Welk land grenst NIET aan Nederland?",
      "options": ["Frankrijk", "Duitsland", "België", "Geen van alle"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Buurlanden van Nederland", "content": "Nederland heeft twee buurlanden: Duitsland (in het oosten) en België (in het zuiden). Frankrijk grenst niet direct aan Nederland — er ligt België tussen.", "icon": "lightbulb"}}],
      "conceptId": "eu_borders_nl",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Nederland heeft maar twee buurlanden: Duitsland (in het oosten) en België (in het zuiden). Frankrijk ligt ten zuiden van België — er zit een heel land tussen Nederland en Frankrijk.",
        "solutionSteps": ["Nederland heeft twee buurlanden: Duitsland en België", "Duitsland grenst in het oosten → grenst wél", "België grenst in het zuiden → grenst wél", "Frankrijk ligt ten zuiden van België → grenst NIET aan Nederland"],
        "distractorExplanations": {
          "0": "Goed! Frankrijk grenst niet aan Nederland — België ligt ertussen.",
          "1": "Duitsland grenst wél aan Nederland (in het oosten). Lees de vraag goed — er wordt gevraagd welk land NIET grenst.",
          "2": "België grenst wél aan Nederland (in het zuiden). Bij een 'NIET'-vraag zoek je het land dat géén grens deelt.",
          "3": "Niet alle genoemde landen zijn buurlanden. Frankrijk grenst niet direct aan Nederland — België ligt ertussen."
        }
      }
    },
    {
      "id": "TOPO-EU-LAND-003",
      "familyId": "TOPO-EU-LAND",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_landen_eu",
      "questionType": "multiple_choice",
      "question": "Welk land is het grootste van Europa qua oppervlakte (exclusief Rusland)?",
      "options": ["Frankrijk", "Spanje", "Duitsland", "Italië"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Grootste landen van Europa", "content": "Frankrijk is het grootste land van de EU (~640.000 km²). Daarna Spanje (~505.000 km²), Duitsland (~357.000 km²) en Italië (~301.000 km²). Rusland is groter maar ligt deels in Azië.", "icon": "lightbulb"}}],
      "conceptId": "eu_country_size",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Frankrijk is met ~640.000 km² het grootste land van de Europese Unie. Het is groter dan Spanje (~505.000 km²) en bijna twee keer zo groot als Duitsland (~357.000 km²). Frankrijk strekt zich uit van de Noordzee tot de Middellandse Zee.",
        "solutionSteps": ["Vergelijk de oppervlaktes van grote EU-landen", "Frankrijk: ~640.000 km² (grootste)", "Spanje: ~505.000 km² (tweede)", "Duitsland: ~357.000 km² (derde)"],
        "distractorExplanations": {
          "0": "Goed! Frankrijk is het grootste land van de EU.",
          "1": "Spanje is het op één na grootste EU-land (~505.000 km²), maar Frankrijk is groter (~640.000 km²). Onthoud: Frankrijk = grootste, Spanje = tweede.",
          "2": "Duitsland heeft de meeste inwoners van de EU, maar qua oppervlakte is het kleiner dan Frankrijk en Spanje. Onthoud: meeste inwoners ≠ grootste oppervlakte.",
          "3": "Italië is kleiner dan alle drie de andere opties (~301.000 km²). Onthoud: Italië is lang en smal (de laars), niet breed."
        }
      }
    },
    {
      "id": "TOPO-EU-LAND-004",
      "familyId": "TOPO-EU-LAND",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_landen_eu",
      "questionType": "multiple_choice",
      "question": "In welk deel van Europa ligt Polen?",
      "options": ["Oost-Europa", "West-Europa", "Zuid-Europa", "Noord-Europa"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Regio's van Europa", "content": "Europa is verdeeld in regio's: West (Frankrijk, VK, Benelux), Oost (Polen, Tsjechië, Hongarije), Zuid (Spanje, Italië, Griekenland), Noord (Scandinavië). Polen ligt ten oosten van Duitsland.", "icon": "lightbulb"}}],
      "conceptId": "eu_regions_poland",
      "variantIndex": 4,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Polen ligt in Oost-Europa, ten oosten van Duitsland. Het grenst aan Duitsland (west), Tsjechië en Slowakije (zuid), Oekraïne en Wit-Rusland (oost), en Litouwen en Rusland (noord).",
        "solutionSteps": ["Polen ligt ten oosten van Duitsland", "Oost-Europa = landen ten oosten van Duitsland/Oostenrijk", "Andere Oost-Europese landen: Tsjechië, Hongarije, Roemenië"],
        "distractorExplanations": {
          "0": "Goed! Polen ligt in Oost-Europa, ten oosten van Duitsland.",
          "1": "West-Europa omvat landen als Frankrijk, het VK en de Benelux. Polen ligt veel oostelijker. Onthoud: Duitsland is de grens tussen West en Oost.",
          "2": "Zuid-Europa omvat landen rond de Middellandse Zee (Spanje, Italië, Griekenland). Polen ligt veel noordelijker. Onthoud: Zuid-Europa = Middellandse Zee.",
          "3": "Noord-Europa omvat Scandinavië (Noorwegen, Zweden, Finland, Denemarken). Polen ligt zuidelijker. Onthoud: Noord-Europa = Scandinavië."
        }
      }
    },
    {
      "id": "TOPO-EU-LAND-005",
      "familyId": "TOPO-EU-LAND",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_landen_eu",
      "questionType": "multiple_choice",
      "question": "Welke twee landen liggen samen op het Iberisch Schiereiland?",
      "options": ["Spanje en Portugal", "Frankrijk en Spanje", "Italië en Griekenland", "Noorwegen en Zweden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Schiereilanden van Europa", "content": "Het Iberisch Schiereiland (zuidwest) = Spanje + Portugal. Het Scandinavisch Schiereiland (noord) = Noorwegen + Zweden. Het Apennijns Schiereiland (zuid) = Italië. Het Balkanschiereiland (zuidoost) = Griekenland + buurlanden.", "icon": "lightbulb"}}],
      "conceptId": "eu_peninsula_iberian",
      "variantIndex": 5,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "Het Iberisch Schiereiland ligt in het zuidwesten van Europa. Spanje (het grote land) en Portugal (de smalle strook aan de westkust) delen dit schiereiland. De Pyreneeën scheiden het Iberisch Schiereiland van Frankrijk.",
        "solutionSteps": ["Het Iberisch Schiereiland ligt in zuidwest-Europa", "Spanje neemt het grootste deel in", "Portugal ligt aan de westkust", "De Pyreneeën vormen de noordgrens"],
        "distractorExplanations": {
          "0": "Goed! Spanje en Portugal liggen samen op het Iberisch Schiereiland.",
          "1": "Frankrijk ligt niet op het Iberisch Schiereiland. De Pyreneeën vormen de grens. Frankrijk ligt ten noorden van de Pyreneeën, Spanje ten zuiden.",
          "2": "Italië en Griekenland liggen op verschillende schiereilanden. Italië = Apennijns Schiereiland, Griekenland = Balkanschiereiland.",
          "3": "Noorwegen en Zweden liggen op het Scandinavisch Schiereiland, in Noord-Europa. Dat is een heel ander schiereiland dan het Iberisch."
        }
      }
    },
    {
      "id": "TOPO-EU-LAND-006",
      "familyId": "TOPO-EU-LAND",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_landen_eu",
      "questionType": "multiple_choice",
      "question": "Welk Europees land is een eiland in de Atlantische Oceaan, ver van het vasteland?",
      "options": ["IJsland", "Ierland", "Groot-Brittannië", "Sicilië"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Eilandlanden in Europa", "content": "IJsland ligt ver in de Atlantische Oceaan, halverwege Europa en Noord-Amerika. Ierland en Groot-Brittannië liggen dicht bij het vasteland. Sicilië is een eiland van Italië, geen apart land.", "icon": "lightbulb"}}],
      "conceptId": "eu_island_iceland",
      "variantIndex": 6,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "IJsland is een eiland in de Atlantische Oceaan, halverwege Europa en Noord-Amerika. Het ligt veel verder van het vasteland dan Ierland of Groot-Brittannië. IJsland is beroemd om vulkanen, geisers en gletsjers.",
        "solutionSteps": ["IJsland ligt in de Atlantische Oceaan", "Het ligt ver van het Europese vasteland", "Ierland en Groot-Brittannië liggen dicht bij het vasteland", "Sicilië is een eiland, maar geen apart land"],
        "distractorExplanations": {
          "0": "Goed! IJsland ligt ver in de Atlantische Oceaan, ver van het vasteland.",
          "1": "Ierland is ook een eiland, maar het ligt dicht bij Groot-Brittannië en het Europese vasteland. IJsland ligt veel verder weg.",
          "2": "Groot-Brittannië is een eiland, maar het ligt dicht bij Frankrijk (het Kanaal is maar ~34 km breed). IJsland ligt veel verder weg.",
          "3": "Sicilië is een eiland bij Italië, maar het is geen apart land — het hoort bij Italië. Bovendien ligt het in de Middellandse Zee, niet de Atlantische Oceaan."
        }
      }
    },
    {
      "id": "TOPO-EU-LAND-007",
      "familyId": "TOPO-EU-LAND",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_landen_eu",
      "questionType": "matching",
      "question": "Koppel elk land aan het deel van Europa waar het ligt.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {"left": "Noorwegen", "right": "Noord-Europa"},
          {"left": "Spanje", "right": "Zuid-Europa"},
          {"left": "Polen", "right": "Oost-Europa"},
          {"left": "Frankrijk", "right": "West-Europa"}
        ]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Regio's van Europa", "content": "Europa is verdeeld in regio's: Noord (Scandinavië), Zuid (Middellandse Zee), Oost (voormalig Oostblok), West (Atlantische kust). Noorwegen = Noord, Spanje = Zuid, Polen = Oost, Frankrijk = West.", "icon": "lightbulb"}}],
      "conceptId": "eu_regions_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Noorwegen ligt in Noord-Europa (Scandinavië), Spanje in Zuid-Europa (Middellandse Zee), Polen in Oost-Europa, en Frankrijk in West-Europa.",
        "solutionSteps": ["Noorwegen → Noord-Europa (Scandinavië)", "Spanje → Zuid-Europa (Middellandse Zee)", "Polen → Oost-Europa", "Frankrijk → West-Europa (Atlantische kust)"]
      }
    },
    {
      "id": "TOPO-EU-LAND-008",
      "familyId": "TOPO-EU-LAND",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_landen_eu",
      "questionType": "matching",
      "question": "Koppel elk Europees schiereiland aan de landen die erop liggen.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {"left": "Iberisch Schiereiland", "right": "Spanje en Portugal"},
          {"left": "Scandinavisch Schiereiland", "right": "Noorwegen en Zweden"},
          {"left": "Apennijns Schiereiland", "right": "Italië"},
          {"left": "Balkanschiereiland", "right": "Griekenland en buurlanden"}
        ]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Schiereilanden van Europa", "content": "Iberisch = Spanje + Portugal (zuidwest). Scandinavisch = Noorwegen + Zweden (noord). Apennijns = Italië (de laars, zuid). Balkan = Griekenland + Servië, Kroatië etc. (zuidoost).", "icon": "lightbulb"}}],
      "conceptId": "eu_peninsulas_matching",
      "variantIndex": 8,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Europa heeft vier grote schiereilanden: Iberisch (Spanje + Portugal), Scandinavisch (Noorwegen + Zweden), Apennijns (Italië) en Balkan (Griekenland en buurlanden).",
        "solutionSteps": ["Iberisch Schiereiland → Spanje en Portugal (zuidwest)", "Scandinavisch Schiereiland → Noorwegen en Zweden (noord)", "Apennijns Schiereiland → Italië (de laars, zuid)", "Balkanschiereiland → Griekenland en buurlanden (zuidoost)"]
      }
    },
    {
      "id": "TOPO-EU-LAND-009",
      "familyId": "TOPO-EU-LAND",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_landen_eu",
      "questionType": "true_false_series",
      "question": "Waar of onwaar? Beoordeel deze stellingen over Europese landen.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Spanje ligt ten zuiden van Frankrijk.", "isTrue": true },
          { "text": "Italië grenst aan Nederland.", "isTrue": false },
          { "text": "Noorwegen ligt in Scandinavië.", "isTrue": true },
          { "text": "Groot-Brittannië is een eiland.", "isTrue": true }
        ]
      },
      "conceptId": "eu_country_facts_series",
      "variantIndex": 9,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Spanje ligt inderdaad ten zuiden van Frankrijk. Italië grenst niet aan Nederland (Duitsland en België wel). Noorwegen is onderdeel van het Scandinavisch schiereiland. Groot-Brittannië is een eilandstaat.",
        "solutionSteps": ["Spanje ligt ten zuiden van Frankrijk (Waar)", "Italië ligt in Zuid-Europa, ver van Nederland (Onwaar)", "Noorwegen ligt in Noord-Europa op het Scandinavisch schiereiland (Waar)", "Groot-Brittannië is omringd door water (Waar)"]
      }
    },
    {
      "id": "TOPO-EU-LAND-010",
      "familyId": "TOPO-EU-LAND",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_landen_eu",
      "questionType": "true_false_series",
      "question": "Waar of onwaar? Beoordeel deze stellingen over Europese landen.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Duitsland is een buurland van Nederland.", "isTrue": true },
          { "text": "Zweden ligt ten zuiden van Italië.", "isTrue": false },
          { "text": "Griekenland ligt aan de Middellandse Zee.", "isTrue": true },
          { "text": "Polen ligt in West-Europa.", "isTrue": false }
        ]
      },
      "conceptId": "eu_country_facts_series_2",
      "variantIndex": 10,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Duitsland ligt ten oosten van Nederland. Zweden ligt in het noorden, Italië in het zuiden. Griekenland ligt in het zuidoosten aan de Middellandse Zee. Polen ligt in Centraal/Oost-Europa.",
        "solutionSteps": [
          "Duitsland is een buurland van Nederland (Waar)",
          "Zweden ligt in het noorden, Italië in het zuiden (Onwaar)",
          "Griekenland ligt in Zuid-Europa aan de Middellandse Zee (Waar)",
          "Polen ligt in Centraal/Oost-Europa (Onwaar)"
        ]
      }
    }
  ]
}